import { render, staticRenderFns } from "./Comparables.vue?vue&type=template&id=dcbbbef8"
import script from "./Comparables.vue?vue&type=script&lang=js"
export * from "./Comparables.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports